import React from "react";
import { BrandMark } from "@/components/BrandMark";

/**
 * Wordmark editorial no estilo do site lcproducao.com.br:
 * "LC" em Cormorant Garamond itálico + "PRODUÇÃO" em Manrope caixa alta espaçada.
 */
export const Wordmark = ({ dark = false, size = 40, tagline = "Música & Experiências · Rio de Janeiro", showLogo = true }) => {
  const primary = dark ? "text-white" : "text-[color:var(--brand-graphite)]";
  const secondary = dark ? "text-white/45" : "text-[color:var(--brand-muted)]";
  return (
    <div className="flex items-center gap-3" data-testid="site-wordmark">
      {showLogo && <BrandMark size={size} />}
      <div className="leading-none">
        <div className="flex items-baseline gap-1.5">
          <span className={`font-serif text-2xl font-semibold italic ${primary}`} style={{ letterSpacing: "0.01em" }}>LC</span>
          <span className={`text-[11px] font-semibold uppercase tracking-[0.34em] ${primary}`}>Produção</span>
        </div>
        {tagline && (
          <div className={`mt-1 text-[9px] font-medium uppercase tracking-[0.28em] ${secondary}`}>{tagline}</div>
        )}
      </div>
    </div>
  );
};

/**
 * Cabeçalho padronizado (Landing / Wizard / Admin).
 * variant: "light" (fundo claro) | "dark" (grafite).
 */
export const SiteHeader = ({
  variant = "light",
  right = null,
  center = null,
  tagline,
  sticky = false,
  size = 40,
  showLogo = true,
  children,
}) => {
  const dark = variant === "dark";
  const base = dark
    ? "bg-[color:var(--brand-graphite)]"
    : "bg-white/85 supports-[backdrop-filter]:bg-white/70 backdrop-blur-md border-b border-[color:var(--brand-border)]";
  return (
    <header data-testid="site-header" className={`${sticky ? "sticky top-0 z-40" : ""} ${base}`}>
      {/* fio de acento superior */}
      <div className="h-[3px] w-full bg-gradient-to-r from-transparent via-[color:var(--brand-champagne)] to-transparent opacity-80" />
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3.5 sm:px-6">
        <Wordmark dark={dark} size={size} tagline={tagline} showLogo={showLogo} />
        {center && <div className="hidden flex-1 justify-center lg:flex">{center}</div>}
        {right && <div className="flex items-center gap-2">{right}</div>}
      </div>
      {children}
    </header>
  );
};
